import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Trophy } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

const VIDEO_ID = "3989HGilMqE";
const HERO_BG =
  "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=2000&q=85";

const ALBUMS = [
  {
    url: "https://andythomasphotography.pic-time.com/pJFWTVSyyXUjO",
    title: "Danielle & Greg",
    img: "https://pictime4neu1public-pub-d2gua5c5f8dfgmem.a02.azurefd.net/pictures/35/775/35775751/homepage/smallres/homepage.jpg?rs=133505176191827283",
  },
  {
    url: "https://andythomasphotography.pic-time.com/GivFewb4YMykI",
    title: "Ellie & Macca",
    img: "https://pictime4neu1public-pub-d2gua5c5f8dfgmem.a02.azurefd.net/pictures/46/745/46745175/homepage/smallres/homepage.jpg?rs=133986476230832322",
  },
  {
    url: "https://andythomasphotography.pic-time.com/i260GxQsDMKaF",
    title: "Vanessa & Robbie",
    img: "https://pictime4neu1public-pub-d2gua5c5f8dfgmem.a02.azurefd.net/pictures/48/400/48400657/homepage/smallres/homepage.jpg?rs=134062902944460921",
  },
  {
    url: "https://andythomasphotography.pic-time.com/Ufxn8fCEV2noH",
    title: "Gemma & James",
    img: "https://pictime4neu1public-pub-d2gua5c5f8dfgmem.a02.azurefd.net/pictures/35/329/35329316/homepage/smallres/homepage.jpg?rs=133484938963086958",
  },
  {
    url: "https://andythomasphotography.pic-time.com/qHsvEBjSzNZdo",
    title: "Alex & Tom",
    img: "https://pictime4neu1public-pub-d2gua5c5f8dfgmem.a02.azurefd.net/pictures/49/560/49560162/homepage/smallres/homepage.jpg?rs=134097588143205721",
  },
];

const HONOURS = [
  "Fellow — Society of Wedding & Portrait Photographers (SWPP)",
  "2× International Wedding Photographer of the Year",
  "3× International Portrait Photographer of the Year",
  "Top 10 World's Best Wedding Photographers · 2019",
  "4× East of England Wedding Photographer of the Year",
  "International Judge · SWPP",
];

const REVIEWS = [
  {
    text: "We asked Chic Photography to be our wedding photographers and I'm so glad we did. From the very beginning Andy was so helpful and made me feel at ease that we were choosing the right package. During the day Andy gave us directions of where to stand and how to pose, and the pictures turned out amazing. Him and his team did a superb job, and I can cherish our wedding day forever with the photos they took.",
    name: "Demi Smith",
  },
  {
    text: "I cannot express how happy me and my husband are with our whole experience with Andy and the team. They were so chilled, making us feel relaxed on the day and answered any questions we had with more than enough detail. We will be forever grateful for the moments and memories the team captured and couldn't thank them enough.",
    name: "Paige Haydon",
  },
  {
    text: "Chic Wedding Photography was an amazing find. Andy and his team really got to understand our vision and worked with us to ensure we were prepared ahead of the wedding. The quality of photos were excellent and so was the service and care given to us throughout the day. We can't think of a single special moment they missed and we now have a record of such wonderful memories with our friends and family.",
    name: "Jasmine Archer",
  },
];

export default function Awards2027() {
  useEffect(() => {
    document.title = "Chic Wedding Photography · Essex Wedding Awards 2027 Entry";
    const prev = document.querySelector('meta[name="robots"]');
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      meta.remove();
      if (prev) document.head.appendChild(prev);
    };
  }, []);

  return (
    <main
      data-testid="awards-page"
      className="bg-[#F6F1E8] text-foreground min-h-screen"
    >
      {/* Discreet top bar */}
      <header className="absolute top-0 inset-x-0 z-20 px-6 md:px-12 lg:px-24 py-6 flex items-center">
        <Link
          to="/"
          data-testid="awards-logo-link"
          className="flex items-center"
          aria-label="Chic Wedding Photography"
        >
          <img
            src="/chic-logo.webp"
            alt="Chic Wedding Photography"
            className="h-9 md:h-11 w-auto brightness-0 invert"
          />
        </Link>
      </header>

      {/* HERO — dark cinematic jury intro */}
      <section
        data-testid="awards-hero"
        className="relative isolate overflow-hidden bg-[#141414] text-[#F6F1E8] pt-32 md:pt-40 pb-16 md:pb-24"
      >
        {/* Background photo + overlays */}
        <div className="absolute inset-0 -z-10">
          <img
            src={HERO_BG}
            alt=""
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#141414]/85 via-[#141414]/70 to-[#141414]" />
        </div>

        <div className="px-6 md:px-12 lg:px-24 text-center max-w-5xl mx-auto">
          {/* Award pill */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease }}
            data-testid="awards-badge"
            className="inline-flex items-center gap-2.5 bg-[#F6F1E8] text-[#1A1A1A] px-5 py-2.5 rounded-full"
          >
            <Trophy className="w-4 h-4" strokeWidth={2} />
            <span className="eyebrow tracking-[0.22em]">
              Essex Wedding Awards 2027 · Photographer of the Year Entry
            </span>
          </motion.div>

          {/* Studio tag */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, ease, delay: 0.15 }}
            className="mt-10 md:mt-14 font-serif-display text-xl md:text-2xl text-[#F6F1E8]/85"
          >
            Chic Wedding{" "}
            <span className="italic text-[#F6F1E8]">Photography</span>
          </motion.p>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease, delay: 0.25 }}
            data-testid="awards-headline"
            className="mt-6 md:mt-8 font-serif-display tracking-tight leading-[1.05] text-[clamp(2.25rem,6.5vw,5.5rem)]"
          >
            The quiet art{" "}
            <span className="italic text-[#F6F1E8]">of being there.</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, ease, delay: 0.45 }}
            className="mt-8 md:mt-10 max-w-2xl mx-auto text-sm md:text-base text-[#F6F1E8]/75 leading-relaxed"
          >
            950+ weddings. 17 years. SWPP Fellow &amp; International Judge.
            Two‑time International Wedding Photographer of the Year. This is
            our Photographer of the Year entry, and below it, the proof.
          </motion.p>

          {/* Stats row */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease, delay: 0.6 }}
            data-testid="awards-stats"
            className="mt-14 md:mt-20 pt-10 md:pt-12 border-t border-[#F6F1E8]/15 grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6 text-left md:text-center"
          >
            {[
              ["950+", "Weddings captured under the Chic brand"],
              ["17+", "Years of photography experience"],
              ["2×", "International Wedding Photographer of the Year"],
              ["SWPP", "Fellow · International Judge"],
            ].map(([stat, label], i) => (
              <div key={i} data-testid={`awards-stat-${i}`}>
                <p className="font-serif-display text-4xl md:text-5xl text-[#F6F1E8] tracking-tight leading-none">
                  {stat}
                </p>
                <p className="mt-3 md:mt-4 eyebrow text-[#F6F1E8]/70 text-[0.62rem] md:text-[0.68rem] leading-relaxed">
                  {label}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* FILM */}
      <section className="px-6 md:px-12 lg:px-24 py-16 md:py-24 bg-[#1A1A1A] text-[#F6F1E8]">
        <div className="max-w-6xl mx-auto">
          <p className="eyebrow opacity-60 mb-5">The Entry Film</p>
          <h2 className="font-serif-display tracking-tight leading-[0.98] text-3xl sm:text-4xl md:text-5xl mb-10 md:mb-14">
            Our <span className="italic">entry</span> video.
          </h2>
          <div
            data-testid="awards-film"
            className="relative w-full aspect-video bg-black overflow-hidden ring-1 ring-[#F6F1E8]/10"
          >
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO_ID}?rel=0&modestbranding=1&playsinline=1`}
              title="Chic Wedding Photography · Essex Wedding Awards 2027 Entry"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          </div>
          <p className="mt-6 text-sm opacity-70 max-w-2xl">
            Best viewed with sound. Full-resolution master available on
            request.
          </p>
        </div>
      </section>

      {/* HONOURS */}
      <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10 items-start">
          <div className="md:col-span-5">
            <p className="eyebrow text-muted-foreground mb-5">
              The Case for Andy
            </p>
            <h2 className="font-serif-display tracking-tight leading-[0.98] text-3xl sm:text-4xl md:text-5xl">
              A photographer the
              <br />
              industry already{" "}
              <span className="italic">calls on</span>
              <br />
              to define the craft.
            </h2>
          </div>
          <div className="md:col-span-7">
            <ul className="divide-y divide-border border-t border-b border-border">
              {HONOURS.map((h, i) => (
                <li
                  key={i}
                  data-testid={`honour-${i}`}
                  className="py-5 md:py-6 flex items-baseline gap-5"
                >
                  <span className="font-serif-display italic text-foreground/50 text-xl md:text-2xl shrink-0 w-10">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-serif-display text-xl md:text-2xl tracking-tight leading-snug">
                    {h}
                  </span>
                </li>
              ))}
            </ul>
            <div className="mt-8 grid grid-cols-2 gap-6 max-w-sm">
              <div className="border-t border-border pt-4">
                <p className="font-serif-display text-3xl md:text-4xl tracking-tight">950+</p>
                <p className="eyebrow text-muted-foreground mt-2">Weddings</p>
              </div>
              <div className="border-t border-border pt-4">
                <p className="font-serif-display text-3xl md:text-4xl tracking-tight">17</p>
                <p className="eyebrow text-muted-foreground mt-2">Years</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section
        data-testid="awards-reviews"
        className="px-6 md:px-12 lg:px-24 py-20 md:py-28 bg-[#1A1A1A] text-[#F6F1E8]"
      >
        <div className="max-w-6xl mx-auto">
          <div className="mb-14 md:mb-20 max-w-3xl">
            <p className="eyebrow opacity-60 mb-5">Words From Our Couples</p>
            <h2 className="font-serif-display tracking-tight leading-[0.98] text-3xl sm:text-4xl md:text-5xl">
              The couples who
              <br />
              <span className="italic">lived it.</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            {REVIEWS.map((r, i) => (
              <motion.figure
                key={r.name}
                data-testid={`review-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.9, ease, delay: i * 0.1 }}
                className="border-t border-[#F6F1E8]/20 pt-8"
              >
                <blockquote className="font-serif-display text-lg md:text-xl leading-[1.4] tracking-tight text-[#F6F1E8]/90">
                  <span className="italic opacity-50">“</span>
                  {r.text}
                  <span className="italic opacity-50">”</span>
                </blockquote>
                <figcaption className="mt-6 eyebrow opacity-80">
                  — {r.name}
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </section>

      {/* ALBUMS */}
      <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28 bg-secondary">
        <div className="mb-14 md:mb-20 max-w-3xl">
          <p className="eyebrow text-muted-foreground mb-5">Submitted Work</p>
          <h2 className="font-serif-display tracking-tight leading-[0.98] text-3xl sm:text-4xl md:text-5xl">
            Five complete albums.
            <br />
            <span className="italic">Open each one.</span>
          </h2>
          <p className="mt-6 text-foreground/75 leading-relaxed">
            Full edits as delivered to the couples. No cherry-picked frames,
            no retouched highlight reels — the entire story, start to finish.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {ALBUMS.map((a, i) => (
            <motion.a
              key={a.url}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`album-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease, delay: i * 0.08 }}
              className="group relative block aspect-[3/4] overflow-hidden bg-secondary"
            >
              <img
                src={a.img}
                alt={a.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-between p-4 md:p-5 text-[#F6F1E8]">
                <p className="eyebrow opacity-80 text-[0.6rem]">
                  No. {String(i + 1).padStart(2, "0")}
                </p>
                <div>
                  <p className="font-serif-display text-lg md:text-xl tracking-tight leading-tight">
                    {a.title}
                  </p>
                  <p className="mt-2 eyebrow opacity-80 group-hover:opacity-100 transition-opacity text-[0.6rem]">
                    Open gallery →
                  </p>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </section>

      {/* CLOSING STATEMENT */}
      <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="max-w-3xl">
          <p className="eyebrow text-muted-foreground mb-6">In Closing</p>
          <blockquote className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            <span className="italic opacity-50">“</span>
            Great wedding photography disappears into the day. What&apos;s left
            is a family&apos;s memory of light, of touch, of the quiet
            moments that would have otherwise been lost.
            <span className="italic opacity-50">”</span>
          </blockquote>
          <p className="mt-10 eyebrow text-foreground/60">
            — Andy Thomas, for the Essex Wedding Awards 2027 Jury
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="px-6 md:px-12 lg:px-24 py-10 border-t border-border flex flex-col sm:flex-row gap-3 sm:items-center justify-between text-xs text-foreground/60">
        <p>Chic Wedding Photography · Unit 6 Hodgson Court, Wickford, Essex, SS11 8XR</p>
        <p>© {new Date().getFullYear()} Chic Wedding Photography</p>
      </footer>
    </main>
  );
}
